import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import ProgramsAssessment from './ProgramsAssessment';
import CoursesAssessment from './CoursesAssessment';

const Dashboard = ({ sidebarExpanded }) => {
  const [currentView, setCurrentView] = useState('dashboard');
  const [currentSchool, setCurrentSchool] = useState('MARYLAND');

  const handleProgramsClick = () => {
    setCurrentView('programs');
  };

  const handleCoursesClick = () => {
    setCurrentView('courses');
  };

  const handleBackClick = () => {
    setCurrentView('dashboard');
  };

  // Get school from URL parameters on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const school = urlParams.get('school');
    if (school) {
      setCurrentSchool(school);
    }
  }, []);

  if (currentView === 'programs') {
    return <ProgramsAssessment onBack={handleBackClick} sidebarExpanded={sidebarExpanded} />;
  }

  if (currentView === 'courses') {
    return <CoursesAssessment onBack={handleBackClick} sidebarExpanded={sidebarExpanded} />;
  }

  return (
    <div className="dashboard">
      <div className="filters">
        <div className="filter">
          <img src="/school.svg" alt="School" className="filter-icon" />
          <select className="filter-select" value={currentSchool} readOnly>
            <option value={currentSchool}>{currentSchool}</option>
          </select>
        </div>
        
        <div className="filter">
          <img src="/page-1-calendar.svg" alt="Calendar" className="filter-icon" />
          <select className="filter-select">
            <option>2025 Spring</option>
          </select>
        </div>
      </div>
      
      <div className="assessment-cards-1">
        <div className="card-1 course-card-1" onClick={handleProgramsClick}>
          <div className="card-content-1">
            <h2>Start Mapping</h2>
            <h2>By Programs</h2>
          </div>
          <img src="/page-1-right-to-start.svg" alt="Programs" className="card-icon" />
        </div>
        
        <div className="card-1 course-card-1" onClick={handleCoursesClick}>
          <div className="card-content-1">
            <h2>Start Mapping</h2>
            <h2>By Courses</h2>
          </div>
          <img src="/page-1-right-to-courses.svg" alt="Courses" className="card-icon" />
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 